var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40180",
    "data-name": "Group 40180",
    transform: "translate(0.672)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14650",
    "data-name": "Rectangle 14650",
    width: 20,
    height: 20,
    transform: "translate(-0.672)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(2.004 1.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33385",
    "data-name": "Path 33385",
    d: "M18.026,17.207l-3.795-3.795a6.967,6.967,0,1,0-.819.819l3.795,3.795a.579.579,0,1,0,.819-.819ZM3.136,8.928a5.793,5.793,0,1,1,5.793,5.793A5.793,5.793,0,0,1,3.136,8.928Z",
    transform: "translate(-1.946 -1.946)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.736befcee408ecda2b6c28d07b31a5ee.svg";
export { ForwardRef as ReactComponent };